<template>
  <div id="activateWrapper">
    <div class="columns">
      <div v-if="user.id" class="column is-half is-offset-one-quarter">
        <div v-show="!activated" class="notification">
          <h1>Welkom bij de Droombronnenbank van de Motiele architect. U heeft een uitnodiging ontvangen om het account van "naam leverancier" te beheren.</h1>

          <p>Voordat u producten of kennisdocumenten in de Droombronnenbank kunt aanmaken of wijzigen, moet u een wachtwoord aanmaken.</p>

          <p>Nadat u een wachtwoord heeft aangemaakt willen we u vragen om de bedrijfsgegevens die wij hebben ingevoerd te controleren en waar nodig aan te vullen of te corrigeren.</p>
        </div>

        <hr/>

        <article v-if="activated" class="message is-success">
          <div class="message-header">
            <p>Geslaagd</p>
            <button class="delete" aria-label="delete"></button>
          </div>

          <div class="message-body">
            Het wachtwoord is opgeslagen en het account is geactiveerd. Hieronder zie je de gegevens die wij hebben van {{ user.supplier.name }}. We willen je vragen deze te controleren en waar nodig te wijzigen of aan te vullen. De bedrijfsgegevens worden uiteindelijk zichtbaar in de Droombronnenbank voor alle gebruikers dus het is belangrijk dat die kloppen.
          </div>
        </article>

        <div class="card" v-if="!activated">
          <div class="card-content">
            <form>
              <div class="field">
                <label for="password" class="label">Kies een nieuw wachtwoord</label>

                <div class="control">
                  <input
                    class="input"
                    :class="{ 'is-danger': errors.password, 'is-success': passwordsMatch }"
                    type="password"
                    name="password"
                    v-model="user.password"
                    placeholder="een wachtwoord moet minimaal 8 karakters hebben">
                </div>

                <p v-for="message in errors.password" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="password_confirmation" class="label">Controle op typefouten</label>

                <div class="control">
                  <input
                    class="input"
                    :class="{ 'is-danger': errors.password_confirmation, 'is-success': passwordsMatch }"
                    type="password"
                    name="password_confirmation"
                    v-model="user.password_confirmation"
                    placeholder="voer nogmaals het gekozen wachtwoord in">
                </div>

                <p v-for="message in errors.password_confirmation" class="help is-danger">{{ message }}</p>
              </div>
            </form>
          </div>

          <footer class="card-footer">
            <a
              class="button is-text card-footer-item"
              @click="save"
              :class="{ 'is-loading': loading }"
              :disabled="disabled">
              Opslaan
            </a>
          </footer>
        </div>

        <div v-else class="card">
          <header class="card-header">
            <p class="card-header-title">Bedrijfsgegevens</p>
          </header>

          <div class="card-content">
            <form>
              <div class="field">
                <label for="name" class="label">Bedrijfsnaam</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="name"
                    :class="{ 'is-danger': errors.name }"
                    v-model="user.supplier.name">
                </div>
                <p v-for="message in errors.name" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="address" class="label">Adres</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="address"
                    :class="{ 'is-danger': errors.address }"
                    v-model="user.supplier.address">
                </div>
                <p v-for="message in errors.address" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="zip" class="label">Postcode</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="zip"
                    :class="{ 'is-danger': errors.zip }"
                    v-model="user.supplier.zip">
                </div>
                <p v-for="message in errors.zip" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="city" class="label">Plaats</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="city"
                    :class="{ 'is-danger': errors.city }"
                    v-model="user.supplier.city">
                </div>
                <p v-for="message in errors.city" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="phone" class="label">Telefoon</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="phone"
                    :class="{ 'is-danger': errors.phone }"
                    v-model="user.supplier.phone">
                </div>
                <p v-for="message in errors.phone" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="email" class="label">Algemeen e-mail adres</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="email"
                    :class="{ 'is-danger': errors.email }"
                    v-model="user.supplier.email">
                </div>
                <p v-for="message in errors.email" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="www" class="label">Website</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    name="www"
                    :class="{ 'is-danger': errors.www }"
                    v-model="user.supplier.www">
                </div>
                <p v-for="message in errors.www" class="help is-danger">{{ message }}</p>
              </div>

            </form>
          </div>

          <footer class="card-footer">
            <button
              class="button is-text card-footer-item"
              @click="saveSupplier"
              :class="{ 'is-loading': loading }"
              :disabled="!user.supplier.name">
              Opslaan
            </button>
          </footer>
        </div>

        <div v-else class="column is-half is-offset-one-quarter">
          <div class="notification is-danger">
            Het account kon niet worden gevonden. Neem contact op met de beheerder.
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import SupplierEdit from '@/components/suppliers/SupplierEdit'

  export default {
    components: {
      SupplierEdit
    },
    data () {
      return {
        loading: false,
        user: {},
        errors: {},
        activated: false
      }
    },
    computed: {
      token () {
        return this.$route.params.token
      },
      passwordsMatch () {
        if (this.user.password)
          if (this.user.password.length > 8 && this.user.password === this.user.password_confirmation)
            return true

        return false
      },
      disabled () {
        return !this.passwordsMatch
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        this.loading = true
        axios
          .get(`/auth/by-activation-code/${this.token}`)
          .then(response => {
            this.loading = false
            this.user = response.data
            this.user.activation_code = this.token
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
      },
      save () {
        this.loading = true

        axios.post(
          '/auth/set-password/',
          this.user
        ).then(response => {
          this.loading = false
          this.activated = true

          this.$store.dispatch('signIn', {
            'email': this.user.email,
            'password': this.user.password
          })
        }).catch(
          error => {
            this.loading = false
            this.errors = error.response.data.errors
          }
        )
      },
      saveSupplier () {
        axios.put(
          '/suppliers/' + this.user.supplier.id,
          this.user.supplier,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        ).then(
          (response) => {
            this.loading = false
            this.$router.push({ name: 'products' })
            location.reload()
          }
        ).catch(
          (error) => {
            this.loading = false
            this.errors = error.response.data.errors
          }
        )
      }
    }
  }
</script>

<style scoped>
  .button.is-text {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/suppliers/SupplierActivate.vue